// Riichi module identifiers that travel inside mj.record.v1.RulesRef (design 1 §6.2, §7; design 2 §6.1).

// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file mj/riichi/v1/riichi.proto (package mj.riichi.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mj/riichi/v1/riichi.proto.
 */
export const file_mj_riichi_v1_riichi: GenFile = /*@__PURE__*/
  fileDesc("Chltai9yaWljaGkvdjEvcmlpY2hpLnByb3RvEgxtai5yaWljaGkudjEiLgoGUGFyYW1zEiQKBmxlbmd0aBgBIAEoDjIULm1qLnJpaWNoaS52MS5MZW5ndGgqmQEKBlByZXNldBIWChJQUkVTRVRfVU5TUEVDSUZJRUQQABIMCghXUkNfMjAyNRABEhEKDVRFTkhPVV80UF9SRUQQAhIUChBURU5IT1VfNFBfTk9fUkVEEAMSFAoQTUpTT1VMXzRQX1JBTktFRBAEEhEKDVRFTkhPVV8zUF9SRUQQBRIXChNURU5IT1VfNFBfTk9fS1VJVEFOEAYqOgoGTGVuZ3RoEhYKEkxFTkdUSF9VTlNQRUNJRklFRBAAEggKBEVBU1QQARIOCgpFQVNUX1NPVVRIEAJiBnByb3RvMw");

/**
 * Per-table preset parameters, carried canon-encoded in RulesRef.params (design 2 Appendix A, tag 19):
 * length u8.
 *
 * @generated from message mj.riichi.v1.Params
 */
export type Params = Message<"mj.riichi.v1.Params"> & {
  /**
   * @generated from field: mj.riichi.v1.Length length = 1;
   */
  length: Length;
};

/**
 * Describes the message mj.riichi.v1.Params.
 * Use `create(ParamsSchema)` to create a new message.
 */
export const ParamsSchema: GenMessage<Params> = /*@__PURE__*/
  messageDesc(file_mj_riichi_v1_riichi, 0);

/**
 * RulesRef.preset for variant RIICHI. Numbers are permanent; only kWrc2025 is a ladder rule set.
 *
 * @generated from enum mj.riichi.v1.Preset
 */
export enum Preset {
  /**
   * @generated from enum value: PRESET_UNSPECIFIED = 0;
   */
  PRESET_UNSPECIFIED = 0,

  /**
   * @generated from enum value: WRC_2025 = 1;
   */
  WRC_2025 = 1,

  /**
   * @generated from enum value: TENHOU_4P_RED = 2;
   */
  TENHOU_4P_RED = 2,

  /**
   * @generated from enum value: TENHOU_4P_NO_RED = 3;
   */
  TENHOU_4P_NO_RED = 3,

  /**
   * @generated from enum value: MJSOUL_4P_RANKED = 4;
   */
  MJSOUL_4P_RANKED = 4,

  /**
   * @generated from enum value: TENHOU_3P_RED = 5;
   */
  TENHOU_3P_RED = 5,

  /**
   * named by design 2 §6.1 for Tenhou's 喰断ナシ lobbies; defined with the importer (M0.3)
   *
   * @generated from enum value: TENHOU_4P_NO_KUITAN = 6;
   */
  TENHOU_4P_NO_KUITAN = 6,
}

/**
 * Describes the enum mj.riichi.v1.Preset.
 */
export const PresetSchema: GenEnum<Preset> = /*@__PURE__*/
  enumDesc(file_mj_riichi_v1_riichi, 0);

/**
 * @generated from enum mj.riichi.v1.Length
 */
export enum Length {
  /**
   * @generated from enum value: LENGTH_UNSPECIFIED = 0;
   */
  LENGTH_UNSPECIFIED = 0,

  /**
   * tonpuusen
   *
   * @generated from enum value: EAST = 1;
   */
  EAST = 1,

  /**
   * hanchan
   *
   * @generated from enum value: EAST_SOUTH = 2;
   */
  EAST_SOUTH = 2,
}

/**
 * Describes the enum mj.riichi.v1.Length.
 */
export const LengthSchema: GenEnum<Length> = /*@__PURE__*/
  enumDesc(file_mj_riichi_v1_riichi, 1);

